var _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg04 = function Svg04(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 174,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "04_svg__b",
    width: 139,
    height: 174,
    x: 0,
    y: 0,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h139v174H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.367 124.144 68.583 1.88h28.272l-65.72 122.264zm0 15.872v-15.872l9.92-10.912H137.03v26.784zM82.967 173V1.88h30.008V173z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0C0C0C",
    d: "M2.367 124.144 68.583 1.88h28.272l-65.72 122.264zm0 15.872v-15.872l9.92-10.912H137.03v26.784zM82.967 173V1.88h30.008V173z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#04_svg__a)",
    d: "m2.367 124.144-.88-.476-.8 1.476h1.68zM68.583 1.88v-1h-.596l-.284.524zm28.272 0 .88.473.793-1.473h-1.673zm-65.72 122.264v1h.598l.283-.527zM2.367 140.016h-1v1h1zm0-15.872-.74-.673-.26.286v.387zm9.92-10.912v-1h-.443l-.297.327zm124.744 0h1v-1h-1zm0 26.784v1h1v-1zM82.967 173h-1v1h1zm0-171.12v-1h-1v1zm30.008 0h1v-1h-1zm0 171.12v1h1v-1zM3.246 124.62 69.462 2.356l-1.759-.952L1.487 123.668zM68.583 2.88h28.272v-2H68.583zm27.39-1.473L30.254 123.67l1.763.946L97.736 2.353zM31.136 123.144H2.367v2h28.768zM3.367 140.016v-15.872h-2v15.872zm-.26-15.199 9.92-10.912-1.48-1.346-9.92 10.912zm9.18-10.585H137.03v-2H12.287zm123.744-1v26.784h2v-26.784zm1 25.784H2.367v2H137.03zM83.967 173V1.88h-2V173zm-1-170.12h30.008v-2H82.967zm29.008-1V173h2V1.88zm1 170.12H82.967v2h30.008z",
    mask: "url(#04_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "04_svg__a",
    x1: 70,
    x2: 75,
    y1: -22.304,
    y2: 179.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96ea63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090B"
  })))));
};
export default Svg04;